import React from "react";

function About() {
  return (
    <div>
      <h1>About our app</h1>
      <p>a app to search github users</p>
      <p>Version : 1.0.0</p>
    </div>
  );
}

export default About;
